module.exports = __webpack_public_path__ + "assets/img/award-1.abafce2a.jpeg";